// Keep this list synchronized with rifacloud-api/src/policies/consumerEmailDomains.js.
export const CONSUMER_EMAIL_DOMAINS = Object.freeze([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'gmx.com',
  'gmx.net',
  'mail.com',
  'yandex.com',
  'yandex.ru',
  'mail.ru',
  'inbox.ru',
  'list.ru',
  'bk.ru',
]);

export const extractEmailDomain = email => {
  const value = String(email || '');
  const at = value.lastIndexOf('@');
  return at === -1 ? '' : value.slice(at + 1).toLowerCase();
};

export const isConsumerEmailDomain = email =>
  CONSUMER_EMAIL_DOMAINS.includes(extractEmailDomain(email));
